import { render, staticRenderFns } from "./SaveChampionshipAsFavoriteButton.vue?vue&type=template&id=30108368&scoped=true"
import script from "./SaveChampionshipAsFavoriteButton.vue?vue&type=script&lang=ts"
export * from "./SaveChampionshipAsFavoriteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30108368",
  null
  
)

export default component.exports